import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './js/app.jsx';
import registerServiceWorker from './registerServiceWorker';

const redirect_uri = window.location.protocol + '//' + window.location.host;
const loginurl =
  'https://www.tvkosice.sk/api/oauth2/authorize?client_id=csm&redirect_uri=' +
  encodeURIComponent(redirect_uri) +
  '&response_type=token&state=';

const root = document.getElementById('app-root');
if (root) {
  ReactDOM.render(<App loginUrl={loginurl} />, root);
}
const mediaBrowserElement = document.getElementById('media-browser-ckeditor');
if (mediaBrowserElement) {
  ReactDOM.render(
    <App isMediaBrowser={true} loginUrl={loginurl} />,
    mediaBrowserElement,
  );
}



// WEBPACK FOOTER //
// ./src/index.js